<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :ok-disabled="disableSubmit"
    :cancelText="language['common.closeButton']">
    <free-back-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit" :colidProps="this.colid" ></free-back-form>
  </j-modal>
</template>

<script>

  import FreeBackForm from './FreeBackForm'
  export default {
    name: 'FreeBackModal',
    components: {
      FreeBackForm
    },
    props: {
      colid: String,
    },
    data () {
      return {
        title:'',
        width:800,
        visible: false,
        disableSubmit: false
      }
    },created() {
    },
    computed: {
      language() {
        return this.$store.getters.language
      }
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>